'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var FormControl_module = require('../styles/FormControl.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Skeleton Avatar component.
 *
 * @component
 * @example
 * ```jsx
 * <Skeleton.Avatar />
 * ```
 */
const HelperText = (props) => {
    const { className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(FormControl_module.default);
    const formControlContext = reactUtils.useFormControlContext();
    const classNames = cx(className, 'helper-text', {
        invalid: formControlContext.invalid,
        disabled: formControlContext.disabled,
    });
    return (React__namespace.createElement("div", { className: classNames, ...restProps }, children));
};
HelperText.displayName = 'HelperText';

exports.default = HelperText;
//# sourceMappingURL=HelperText.js.map
